import { useEffect } from "react";

/**
 * `defaultOpen`: the host wants the panel open on mount. It is requested through the shell's guarded open
 * (the same path as a launcher tap), so it waits for config / the handshake and, when auth fails, shows the
 * retry popup instead of an open panel that cannot work. A controlled `open` wins and is driven by `useHostOpen`.
 * Mount only: afterwards the visitor owns the state.
 */
export function useDefaultOpen(
  open: boolean | undefined,
  defaultOpen: boolean | undefined,
  request: () => void,
) {
  // biome-ignore lint/correctness/useExhaustiveDependencies: a one-shot on mount; later prop changes must not re-open
  useEffect(() => {
    if (open === undefined && defaultOpen) request();
  }, []);
}
